//# sourceMappingURL=my-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-date.interface.js
// module id = 576
// module chunks = 10